import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date()?.getFullYear();
  
  return (
    <footer className="border-t py-8 text-center text-sm text-gray-500 mt-16">
      <p className="mb-2">© {currentYear} Creative Brains LTD. All rights reserved.</p>
      <p className="mb-4 text-xs text-gray-400">Creative Brains LTD, London, United Kingdom.</p>
      <div className="flex justify-center gap-4">
        <Link to="/privacy-policy" className="underline">
          Privacy Policy
        </Link>
        <Link to="/terms" className="underline">
          Terms & Conditions
        </Link>
         <Link to="/data-deletion" className="underline">
          Data Deletion
        </Link>
        <Link to="/contact" className="underline">
          Contact
        </Link>

      </div>
    </footer>
  );
}
